module.exports = __webpack_public_path__ + "static/media/promo-cta-background.dad170e9.png";